import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const usePopularSearches = () => {
  const key = 'v1/search_v3/populars/';
  const { data: popularSearches, ...rest } = useFetch(key, {
    hostType: HOST_TYPE.BACKEND_API_HOST
  });
  return { popularSearches, ...rest };
};

export default usePopularSearches;
